import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b32a6d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title m-0" }
const _hoisted_5 = { class: "fw-boldest m-0" }
const _hoisted_6 = { class: "card-body p-9" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group d-flex flex-wrap" }
const _hoisted_10 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group d-flex flex-wrap" }
const _hoisted_13 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "el-form-item__content" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group d-flex flex-wrap" }
const _hoisted_20 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "form-group d-flex flex-wrap" }
const _hoisted_23 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group d-flex flex-wrap" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = {
  key: 0,
  class: "form-group d-flex flex-wrap"
}
const _hoisted_28 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_29 = {
  key: 1,
  class: "form-group d-flex flex-wrap"
}
const _hoisted_30 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group d-flex flex-wrap" }
const _hoisted_36 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "el-upload__tip" }
const _hoisted_45 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_46 = { class: "card-header" }
const _hoisted_47 = { class: "card-title m-0" }
const _hoisted_48 = { class: "fw-boldest m-0" }
const _hoisted_49 = { class: "card-body p-9" }
const _hoisted_50 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_51 = { class: "d-flex flex-column" }
const _hoisted_52 = { class: "fs-6 text-gray-400 text-uppercase" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "svg-icon svg-icon-3" }
const _hoisted_55 = { class: "card mb-5 mb-xl-10" }
const _hoisted_56 = { class: "card-header" }
const _hoisted_57 = { class: "card-title m-0" }
const _hoisted_58 = { class: "fw-boldest m-0" }
const _hoisted_59 = { class: "card-body p-9" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "form-group d-flex flex-wrap" }
const _hoisted_63 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "form-group d-flex flex-wrap" }
const _hoisted_66 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "form-group d-flex flex-wrap" }
const _hoisted_69 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "form-group d-flex flex-wrap" }
const _hoisted_72 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_73 = { class: "card mb-5 mb-xl-10" }
const _hoisted_74 = { class: "card-header" }
const _hoisted_75 = { class: "card-title m-0" }
const _hoisted_76 = { class: "fw-boldest m-0" }
const _hoisted_77 = { class: "card-body p-9" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "form-group d-flex flex-wrap" }
const _hoisted_81 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "form-group d-flex flex-wrap" }
const _hoisted_84 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "form-group d-flex flex-wrap" }
const _hoisted_87 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group d-flex flex-wrap" }
const _hoisted_90 = { class: "card mb-5 mb-xl-10" }
const _hoisted_91 = { class: "card-header" }
const _hoisted_92 = { class: "card-title m-0" }
const _hoisted_93 = { class: "fw-boldest m-0" }
const _hoisted_94 = { class: "card-body p-9" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = { class: "form-group d-flex flex-wrap" }
const _hoisted_98 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "form-group d-flex flex-wrap" }
const _hoisted_101 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_102 = { class: "col-md-6" }
const _hoisted_103 = { class: "form-group d-flex flex-wrap" }
const _hoisted_104 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_105 = { class: "col-md-6" }
const _hoisted_106 = { class: "form-group d-flex flex-wrap" }
const _hoisted_107 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_108 = { class: "card mb-5 mb-xl-10" }
const _hoisted_109 = { class: "card-header" }
const _hoisted_110 = { class: "card-title m-0" }
const _hoisted_111 = { class: "fw-boldest m-0" }
const _hoisted_112 = { class: "card-body p-9" }
const _hoisted_113 = { class: "row" }
const _hoisted_114 = { class: "col-md-6" }
const _hoisted_115 = { class: "form-group d-flex flex-wrap" }
const _hoisted_116 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_117 = { class: "col-md-6" }
const _hoisted_118 = { class: "form-group d-flex flex-wrap" }
const _hoisted_119 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_120 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " EUR ", -1))
const _hoisted_122 = { class: "col-md-6" }
const _hoisted_123 = { class: "form-group d-flex flex-wrap" }
const _hoisted_124 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_125 = { class: "col-md-6" }
const _hoisted_126 = { class: "form-group d-flex flex-wrap" }
const _hoisted_127 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_128 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_129 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_130 = { class: "col-md-6" }
const _hoisted_131 = { class: "form-group d-flex flex-wrap" }
const _hoisted_132 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_133 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_134 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_135 = { class: "col-md-6" }
const _hoisted_136 = { class: "form-group d-flex flex-wrap" }
const _hoisted_137 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_138 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_139 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_140 = { class: "col-md-6" }
const _hoisted_141 = { class: "form-group d-flex flex-wrap" }
const _hoisted_142 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_143 = { class: "col-md-6" }
const _hoisted_144 = { class: "form-group d-flex flex-wrap" }
const _hoisted_145 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_146 = { class: "col-md-6" }
const _hoisted_147 = { class: "form-group d-flex flex-wrap" }
const _hoisted_148 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_149 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_150 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_151 = { class: "col-md-6" }
const _hoisted_152 = { class: "form-group d-flex flex-wrap" }
const _hoisted_153 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_154 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_155 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_156 = { class: "col-md-6" }
const _hoisted_157 = { class: "form-group d-flex flex-wrap" }
const _hoisted_158 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_159 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_160 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_161 = { class: "card mb-5 mb-xl-10" }
const _hoisted_162 = { class: "card-header" }
const _hoisted_163 = { class: "d-flex flex-row align-items-center" }
const _hoisted_164 = { class: "mb-0" }
const _hoisted_165 = {
  key: 0,
  type: "button",
  class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
  "aria-disabled": "true",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_pre_stock_out_list",
  title: "Add"
}
const _hoisted_166 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_167 = { class: "card-body p-9" }
const _hoisted_168 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_169 = { class: "fs-6 text-gray-400 text-uppercase" }
const _hoisted_170 = ["onClick"]
const _hoisted_171 = { class: "svg-icon svg-icon-3" }
const _hoisted_172 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_173 = { class: "card-header" }
const _hoisted_174 = { class: "d-flex flex-row align-items-center" }
const _hoisted_175 = { class: "mb-0" }
const _hoisted_176 = {
  key: 0,
  type: "button",
  class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
  "aria-disabled": "true",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_pre_stock_out_list",
  title: "Add"
}
const _hoisted_177 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_178 = { class: "card-body p-9" }
const _hoisted_179 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_180 = { class: "d-flex flex-column" }
const _hoisted_181 = { class: "fs-6 text-gray-400 text-uppercase" }
const _hoisted_182 = ["onClick"]
const _hoisted_183 = { class: "svg-icon svg-icon-3" }
const _hoisted_184 = { class: "card mb-5 mb-xl-10" }
const _hoisted_185 = { class: "card-header" }
const _hoisted_186 = { class: "card-title m-0" }
const _hoisted_187 = { class: "fw-boldest m-0" }
const _hoisted_188 = { class: "card-body p-9" }
const _hoisted_189 = { class: "row" }
const _hoisted_190 = { class: "mb-10" }
const _hoisted_191 = { class: "py-6 px-9" }
const _hoisted_192 = { class: "header position-fixed bottom-0 end-0 d-flex justify-content-between py-6 px-9 bg-white content-fixed-bottom" }
const _hoisted_193 = { class: "svg-icon svg-icon-2" }
const _hoisted_194 = { class: "d-flex gap-2" }
const _hoisted_195 = ["disabled"]
const _hoisted_196 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_197 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_198 = ["disabled"]
const _hoisted_199 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_200 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_201 = ["disabled"]
const _hoisted_202 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_203 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_204 = ["disabled"]
const _hoisted_205 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_206 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_207 = ["disabled"]
const _hoisted_208 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_209 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_210 = ["disabled"]
const _hoisted_211 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_212 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_213 = ["disabled"]
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_215 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_216 = ["disabled"]
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_218 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_219 = ["disabled"]
const _hoisted_220 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_221 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_222 = ["disabled"]
const _hoisted_223 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_224 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_225 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-light-primary"
}
const _hoisted_226 = { class: "indicator-label" }
const _hoisted_227 = { class: "svg-icon svg-icon-2" }
const _hoisted_228 = { class: "indicator-progress" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_230 = ["disabled"]
const _hoisted_231 = { class: "indicator-label" }
const _hoisted_232 = { class: "svg-icon svg-icon-2" }
const _hoisted_233 = { class: "indicator-progress" }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_UseStockOut = _resolveComponent("UseStockOut")!
  const _component_addPreStockOutList = _resolveComponent("addPreStockOutList")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        onSubmit: _cache[50] || (_cache[50] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t("common.information")), 1)
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("shipments.id")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.shipment_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.shipment_info.shipment_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.shipment_info.shipment_id) = $event)),
                          type: "text",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("shipments.creationDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.created_at" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.shipment_info.created_at,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.shipment_info.created_at) = $event)),
                          type: "datetime",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("shipments.status")), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", 
                      _ctx.getShipmentStatusMap(
                        Number(_ctx.formData.shipment_info.status)
                      )
                    ])
                      }, _toDisplayString(_ctx.formData.__show.status), 3)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("shipments.type")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.shipment_type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.shipment_info.shipment_type,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.shipment_info.shipment_type) = $event)),
                          clearable: "",
                          style: {"width":"100%"},
                          disabled: "",
                          placeholder: " "
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.shipment_type, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("shipments.fulfillmentStage")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.fulfillment_stage" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.shipment_info.fulfillment_stage,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.shipment_info.fulfillment_stage) = $event)),
                          size: "mini",
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fulfillment_stage, (item) => {
                              return (_openBlock(), _createBlock(_component_el_radio_button, {
                                key: item.value,
                                label: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["col-form-label fw-bold fs-6", {
                    required:
                      _ctx.typeSameRule &&
                      _ctx.formData.shipment_info.status ==
                        String(_ctx.ShipmentStatus.Created),
                  }])
                    }, _toDisplayString(_ctx.t("shipments.serviceProvider")), 3),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.service_provider" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.shipment_info.service_provider,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.shipment_info.service_provider) = $event)),
                          filterable: "",
                          disabled: 
                      (_ctx.typeSameRule &&
                        _ctx.formData.shipment_info.status !=
                          String(_ctx.ShipmentStatus.Created)) ||
                      _ctx.formData.shipment_info.shipment_type == '1' ||
                      _ctx.formData.shipment_info.invoice_status !== 10
                    ,
                          placeholder: _ctx.t('common.plsSelect'),
                          onChange: _ctx.serviceProviderChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.service_provider, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled", "placeholder", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.formData.shipment_info.service_provider != -1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("shipments.trackingNo")), 1),
                        _createVNode(_component_el_form_item, { prop: "shipment_info.tracking_no" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.shipment_info.tracking_no,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.shipment_info.tracking_no) = $event)),
                              type: "text",
                              disabled: _ctx.isDisabledTrackingNo,
                              placeholder: 
                      !_ctx.isDisabledTrackingNo ? _ctx.t('common.plsEnter') : ''
                    
                            }, null, 8, ["modelValue", "disabled", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("shipments.pickUpBy")), 1),
                        _createVNode(_component_el_form_item, { prop: "shipment_info.pick_up_by" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.shipment_info.pick_up_by,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.shipment_info.pick_up_by) = $event)),
                              type: "text",
                              clearable: "",
                              disabled: 
                      !_ctx.typeSameRule ||
                      (_ctx.formData.shipment_info.status !=
                        String(_ctx.ShipmentStatus.Created) &&
                        _ctx.typeSameRule) ||
                      _ctx.formData.shipment_info.invoice_status !== 10
                    ,
                              placeholder: 
                      _ctx.formData.shipment_info.status ==
                        String(_ctx.ShipmentStatus.Created) && _ctx.typeSameRule
                        ? _ctx.t('common.plsEnter')
                        : ''
                    
                            }, null, 8, ["modelValue", "disabled", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("shipments.departureDeliveryFrom")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.delivery_from" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: 
                      _ctx.getLocation(
                        _ctx.formData.shipment_info.delivery_from_location,
                        true
                      )
                    ,
                          type: "textarea",
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("shipments.destination")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.destination" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: 
                      _ctx.getLocation(_ctx.formData.shipment_info.destination_location)
                    ,
                          type: "textarea",
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("h3", null, _toDisplayString(_ctx.t("common.fileUpload")), 1),
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("shipments.logisticsDocuments")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.file_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          ref: "upload_file_id",
                          accept: ".pdf",
                          "file-list": _ctx.options.file_id,
                          action: _ctx.uploadUrl,
                          data: { id: _ctx.id },
                          headers: _ctx.uploadHeaders,
                          disabled: _ctx.uploadDisabled.file_id,
                          limit: 1,
                          "auto-upload": true,
                          "on-progress": 
                      function (e, file, fileList) {
                        return _ctx.handleProgress(e, file, fileList, 'file_id');
                      }
                    ,
                          "on-success": 
                      function (response, file, fileList) {
                        return _ctx.handleSuccess(
                          response,
                          file,
                          fileList,
                          'file_id',
                          _ctx.formData.shipment_info
                        );
                      }
                    ,
                          "on-error": 
                      function (err, file, fileList) {
                        return _ctx.handleError(err, file, fileList, 'file_id');
                      }
                    ,
                          "on-remove": 
                      function (file, fileList) {
                        return _ctx.handleRemove(
                          file,
                          fileList,
                          'file_id',
                          _ctx.formData.shipment_info,
                          _ctx.options,
                          _ctx.removeFlag
                        );
                      }
                    ,
                          "on-exceed": 
                      function (files, fileList) {
                        return _ctx.handleExceed(files, fileList, 'file_id');
                      }
                    ,
                          "before-upload": _ctx.handleBeforeUpload
                        }, {
                          trigger: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "btn btn-primary btn-sm me-2",
                              disabled: _ctx.uploadDisabled.file_id
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t("common.fileUpload")), 1)
                            ], 8, _hoisted_41)), [
                              [_directive_auth, { auth: ['update'] }]
                            ])
                          ]),
                          tip: _withCtx(() => [
                            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.t("common.uploadTip")), 1)
                          ]),
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "btn btn-danger btn-sm me-2",
                              disabled: 
                        _ctx.uploadDisabled.file_id ||
                        _ctx.formData.shipment_info.file_id === 0
                      ,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (
                        _ctx.handleDeleteUpload('file_id', _ctx.formData.shipment_info)
                      ))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t("common.fileDelete")), 1)
                            ], 8, _hoisted_42)), [
                              [_directive_auth, { auth: ['update'] }]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "btn btn-success btn-sm me-2",
                              disabled: 
                        _ctx.uploadDisabled.file_id ||
                        _ctx.formData.shipment_info.file_id === 0
                      ,
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handlePreview('file_id', _ctx.formData.shipment_info)))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t("common.filePreview")), 1)
                            ], 8, _hoisted_43)), [
                              [_directive_auth, { auth: ['export'] }]
                            ])
                          ]),
                          _: 1
                        }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          (_ctx.formData.shipment_info.shipment_type == '1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.t("shipments.itemsList")), 1)
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createVNode(_component_el_table, {
                    class: "w-100 text-xs",
                    data: _ctx.formData.shipment_items,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.product'),
                        width: "500"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_product_info, {
                            gallery: _ctx.getProductIdData(row.sku_identifier)?.gallery,
                            name: _ctx.getProductIdData(row.sku_identifier)?.name,
                            name_en: _ctx.getProductIdData(row.sku_identifier)?.name_en,
                            source_link: 
                      _ctx.getProductIdData(row.sku_identifier)?.source_link
                    ,
                            brand_id: 
                      _ctx.getProductIdData(row.sku_identifier)?.__show.brand_id
                    
                          }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.sku'),
                        width: "200"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_sku_info, {
                            brand_article_no: 
                      _ctx.getProductIdData(row.sku_identifier)?.brand_article_no
                    ,
                            color: 
                      _ctx.getProductIdData(row.sku_identifier)?.original_color
                    ,
                            size: _ctx.getProductIdData(row.sku_identifier)?.__show.size,
                            product_identifier_id: 
                      _ctx.getProductIdData(row.sku_identifier)
                        ?.product_identifier_id
                    
                          }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('salesOrder.orderNumber'),
                        width: "320"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", null, _toDisplayString(row.sale_order_number), 1),
                              _createElementVNode("div", _hoisted_52, " SUB#" + _toDisplayString(row.order_item_position) + " (" + _toDisplayString(row.quantity) + ") ", 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.quantity'),
                        prop: "quantity",
                        align: "right"
                      }, null, 8, ["label"]),
                      (
                  _ctx.formData.shipment_info.status !== '' &&
                  !_ctx.loading &&
                  _ctx.formData.shipment_info.invoice_status !== 0
                )
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            label: "",
                            align: "right",
                            width: "100"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_use_stock_out",
                                onClick: ($event: any) => (_ctx.handleEditUseStockOut(row))
                              }, [
                                _createElementVNode("span", _hoisted_54, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                ])
                              ], 8, _hoisted_53)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data"])
                ])), [
                  [_directive_loading, _ctx.options.loadingProducts]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.t("shipments.lifecycle")), 1)
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.t("shipments.actualTimeOfDepartureAtd")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.actual_time_of_departure" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.shipment_info.actual_time_of_departure,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.shipment_info.actual_time_of_departure) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          "disabled-date": _ctx.setDisabledDate,
                          disabled: 
                      _ctx.options.defaultFormData.actual_time_of_departure != ''
                    ,
                          onChange: _cache[10] || (_cache[10] = ($event: any) => (
                      _ctx.commonChangeDefaultDate(
                        $event,
                        _ctx.formData,
                        'shipment_info',
                        'actual_time_of_departure'
                      )
                    ))
                        }, null, 8, ["modelValue", "placeholder", "disabled-date", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.t("shipments.estimatedTimeOfDepartureEtd")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.estimated_time_of_departure" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.shipment_info.estimated_time_of_departure,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.shipment_info.estimated_time_of_departure) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (
                      _ctx.commonChangeDefaultDate(
                        $event,
                        _ctx.formData,
                        'carrier_information',
                        'flight_departure_date'
                      )
                    ))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.t("shipments.actualTimeOfArrivalAta")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.actual_time_of_arrival" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.shipment_info.actual_time_of_arrival,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.shipment_info.actual_time_of_arrival) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[14] || (_cache[14] = ($event: any) => (
                      _ctx.commonChangeDefaultDate(
                        $event,
                        _ctx.formData,
                        'shipment_info',
                        'actual_time_of_arrival'
                      )
                    ))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.t("shipments.estimatedTimeOfArrivalEta")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipment_info.estimated_time_of_arrival" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.shipment_info.estimated_time_of_arrival,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.shipment_info.estimated_time_of_arrival) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[16] || (_cache[16] = ($event: any) => (
                      _ctx.commonChangeDefaultDate(
                        $event,
                        _ctx.formData,
                        'shipment_info',
                        'estimated_time_of_arrival'
                      )
                    ))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          (_ctx.formData.shipment_info.shipment_type == '2')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("h3", _hoisted_76, _toDisplayString(_ctx.t("shipments.carrierInformation")), 1)
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.t("shipments.flightNumber")), 1),
                          _createVNode(_component_el_form_item, { prop: "carrier_information.flight_number" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.carrier_information.flight_number,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.carrier_information.flight_number) = $event)),
                                type: "text",
                                placeholder: _ctx.t('common.plsEnter'),
                                clearable: ""
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.t("shipments.flightDepartureDate")), 1),
                          _createVNode(_component_el_form_item, { prop: "carrier_information.flight_departure_date" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: 
                        _ctx.formData.carrier_information.flight_departure_date
                      ,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((
                        _ctx.formData.carrier_information.flight_departure_date
                      ) = $event)),
                                type: "date",
                                clearable: "",
                                placeholder: _ctx.t('common.pickDate'),
                                style: {"width":"100%"},
                                onChange: _cache[19] || (_cache[19] = ($event: any) => (
                        _ctx.commonChangeDefaultDate(
                          $event,
                          _ctx.formData,
                          'carrier_information',
                          'flight_departure_date'
                        )
                      ))
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.t("shipments.flightLandingDate")), 1),
                          _createVNode(_component_el_form_item, { prop: "carrier_information.flight_landing_date" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.formData.carrier_information.flight_landing_date,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.carrier_information.flight_landing_date) = $event)),
                                type: "date",
                                clearable: "",
                                placeholder: _ctx.t('common.pickDate'),
                                style: {"width":"100%"},
                                onChange: _cache[21] || (_cache[21] = ($event: any) => (
                        _ctx.commonChangeDefaultDate(
                          $event,
                          _ctx.formData,
                          'carrier_information',
                          'flight_landing_date'
                        )
                      ))
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["col-form-label fw-bold fs-6", {
                      required:
                        _ctx.formData.shipment_info.delivery_from_location.type !==
                        1,
                    }])
                          }, _toDisplayString(_ctx.t("shipments.destinationPort")), 3),
                          _createVNode(_component_el_form_item, { prop: "carrier_information.destination_port" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.carrier_information.destination_port,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.carrier_information.destination_port) = $event)),
                                clearable: "",
                                style: {"width":"100%"},
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.shipments_destination_port, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.loading]
                  ])
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("h3", _hoisted_93, _toDisplayString(_ctx.t("shipments.customDeclaration")), 1)
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.t("shipments.customDeclarationBy")), 1),
                          _createVNode(_component_el_form_item, { prop: "carrier_information.custom_declaration_by" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: 
                        _ctx.formData.carrier_information.custom_declaration_by
                      ,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
                        _ctx.formData.carrier_information.custom_declaration_by
                      ) = $event)),
                                clearable: "",
                                style: {"width":"100%"},
                                placeholder: " ",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.custom_declaration_by, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.t("shipments.exportCustomDeclaration")), 1),
                          _createVNode(_component_el_form_item, { prop: "export_custom_declaration" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: 
                        _ctx.formData.carrier_information.export_custom_declaration
                      ,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((
                        _ctx.formData.carrier_information.export_custom_declaration
                      ) = $event)),
                                type: "text",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.t("shipments.importCustomDeclaration")), 1),
                          _createVNode(_component_el_form_item, { prop: "carrier_information.import_custom_declaration" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: 
                        _ctx.formData.carrier_information.import_custom_declaration
                      ,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((
                        _ctx.formData.carrier_information.import_custom_declaration
                      ) = $event)),
                                type: "text",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.t("shipments.tradeTerm")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipment_info.trade_term" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.shipment_info.trade_term,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.shipment_info.trade_term) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect'),
                                disabled: 
                        _ctx.formData.shipment_info.status !=
                          String(_ctx.ShipmentStatus.Created) ||
                        _ctx.formData.shipment_invoice_id !== 0 ||
                        _ctx.formData.shipment_info.invoice_status !== 10
                      
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.tms_shipment_trade_term, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.loading]
                  ])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("h3", _hoisted_111, _toDisplayString(_ctx.t("shipments.packingSpecification")), 1)
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.t("shipments.totalNoOfPieces")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.quantity" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.packing_specification.quantity,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.packing_specification.quantity) = $event)),
                                type: "number",
                                placeholder: _ctx.t('common.plsEnter'),
                                clearable: ""
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.t("shipments.customsValueShipping")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.total_amount" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_120, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: _ctx.formData.packing_specification.total_amount,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.packing_specification.total_amount) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _hoisted_121
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, [
                          _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.t("shipments.totalVolumeWeight")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.total_volume_weight" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                class: "text-start",
                                modelValue: 
                        _ctx.formData.packing_specification.total_volume_weight
                      ,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((
                        _ctx.formData.packing_specification.total_volume_weight
                      ) = $event)),
                                precision: 2,
                                step: 0.01,
                                controls: false,
                                style: {"width":"100%"}
                              }, {
                                append: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("shipments.weightUnit")), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "step"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.t("shipments.totalGrossWeightGw")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.total_gross_weight" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_128, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: 
                          _ctx.formData.packing_specification.total_gross_weight
                        ,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((
                          _ctx.formData.packing_specification.total_gross_weight
                        ) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.t("shipments.weightUnit")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.t("shipments.chargeableWeight")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.chargeable_weight" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_133, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: 
                          _ctx.formData.packing_specification.chargeable_weight
                        ,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((
                          _ctx.formData.packing_specification.chargeable_weight
                        ) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _createElementVNode("div", _hoisted_134, _toDisplayString(_ctx.t("shipments.weightUnit")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("div", _hoisted_136, [
                          _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.t("shipments.totalVolumeVol")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.total_volume" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_138, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: _ctx.formData.packing_specification.total_volume,
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.packing_specification.total_volume) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.t("shipments.volumeUnit")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.t("shipments.packingContainer")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.packing_container" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.packing_specification.packing_container,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.packing_specification.packing_container) = $event)),
                                clearable: "",
                                style: {"width":"100%"},
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.packing_container, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("div", _hoisted_144, [
                          _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.t("shipments.dimension")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.dimension" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.packing_specification.dimension,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.packing_specification.dimension) = $event)),
                                type: "number",
                                placeholder: _ctx.t('common.plsEnter')
                              }, {
                                append: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("shipments.lengthUnit")), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_146, [
                        _createElementVNode("div", _hoisted_147, [
                          _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.t("shipments.actualGrossWeight")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.actual_gross_weight" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_149, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: 
                          _ctx.formData.packing_specification.actual_gross_weight
                        ,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((
                          _ctx.formData.packing_specification.actual_gross_weight
                        ) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _createElementVNode("div", _hoisted_150, _toDisplayString(_ctx.t("shipments.weightUnit")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.t("shipments.shipmentFeeAmount")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.shipment_fee_amount" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_154, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: 
                          _ctx.formData.packing_specification.shipment_fee_amount
                        ,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((
                          _ctx.formData.packing_specification.shipment_fee_amount
                        ) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _createElementVNode("div", _hoisted_155, _toDisplayString(_ctx.formData.packing_specification.shipment_fee_currency), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_156, [
                        _createElementVNode("div", _hoisted_157, [
                          _createElementVNode("label", _hoisted_158, _toDisplayString(_ctx.t("shipments.additionalFeeAmount")), 1),
                          _createVNode(_component_el_form_item, { prop: "packing_specification.additional_fee_amount" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_159, [
                                _createVNode(_component_el_input_number, {
                                  class: "text-start w-100",
                                  modelValue: 
                          _ctx.formData.packing_specification.additional_fee_amount
                        ,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((
                          _ctx.formData.packing_specification.additional_fee_amount
                        ) = $event)),
                                  precision: 2,
                                  step: 0.01,
                                  controls: false
                                }, null, 8, ["modelValue", "step"]),
                                _createElementVNode("div", _hoisted_160, _toDisplayString(_ctx.formData.packing_specification.additional_fee_currency), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.loading]
                  ])
                ]),
                _createElementVNode("div", _hoisted_161, [
                  _createElementVNode("div", _hoisted_162, [
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("h3", _hoisted_164, _toDisplayString(_ctx.t("shipments.itemList")), 1),
                      _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                        default: _withCtx(() => [
                          (_ctx.isShowAddPreStockOut)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_165, [
                                _createElementVNode("span", _hoisted_166, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_167, [
                    _createVNode(_component_el_table, {
                      data: _ctx.formData.shipment_items,
                      style: {"width":"100%"},
                      size: "small",
                      "min-width": "220"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.product'),
                          width: "500"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_product_info, {
                              gallery: _ctx.getProductIdData(row.sku_identifier)?.gallery,
                              name: _ctx.getProductIdData(row.sku_identifier)?.name,
                              name_en: _ctx.getProductIdData(row.sku_identifier)?.name_en,
                              source_link: 
                      _ctx.getProductIdData(row.sku_identifier)?.source_link
                    ,
                              brand_id: 
                      _ctx.getProductIdData(row.sku_identifier)?.__show.brand_id
                    
                            }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.sku'),
                          width: "200"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_sku_info, {
                              brand_article_no: 
                      _ctx.getProductIdData(row.sku_identifier)?.brand_article_no
                    ,
                              color: 
                      _ctx.getProductIdData(row.sku_identifier)?.original_color
                    ,
                              size: _ctx.getProductIdData(row.sku_identifier)?.__show.size,
                              product_identifier_id: 
                      _ctx.getProductIdData(row.sku_identifier)
                        ?.product_identifier_id
                    
                            }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('salesOrder.orderNumber'),
                          width: "320"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("div", _hoisted_168, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.order, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex flex-column",
                                  key: index
                                }, [
                                  _createElementVNode("div", null, _toDisplayString(item.order_number), 1),
                                  _createElementVNode("div", _hoisted_169, " SUB#" + _toDisplayString(item.order_item_position) + " (" + _toDisplayString(item.quantity) + ") ", 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.quantity'),
                          prop: "quantity",
                          align: "right"
                        }, null, 8, ["label"]),
                        (
                  _ctx.formData.shipment_info.status !== '' &&
                  !_ctx.loading &&
                  _ctx.formData.shipment_info.invoice_status !== 0
                )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              label: "",
                              align: "right",
                              width: "100"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#modal_use_stock_out",
                                  onClick: ($event: any) => (_ctx.handleEditUseStockOut(row))
                                }, [
                                  _createElementVNode("span", _hoisted_171, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                  ])
                                ], 8, _hoisted_170)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ])), [
                    [_directive_loading, _ctx.options.loadingProducts]
                  ])
                ])
              ], 64))
            : (_ctx.formData.shipment_info.shipment_type == '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("h3", _hoisted_175, _toDisplayString(_ctx.t("shipments.itemList")), 1),
                      _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                        default: _withCtx(() => [
                          (_ctx.isShowAddPreStockOut)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_176, [
                                _createElementVNode("span", _hoisted_177, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_178, [
                    _createVNode(_component_el_table, {
                      class: "w-100 text-xs",
                      data: _ctx.formData.shipment_items,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.product'),
                          width: "500"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_product_info, {
                              gallery: _ctx.getProductIdData(row.sku_identifier)?.gallery,
                              name: _ctx.getProductIdData(row.sku_identifier)?.name,
                              name_en: _ctx.getProductIdData(row.sku_identifier)?.name_en,
                              source_link: 
                      _ctx.getProductIdData(row.sku_identifier)?.source_link
                    ,
                              brand_id: 
                      _ctx.getProductIdData(row.sku_identifier)?.__show.brand_id
                    
                            }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.sku'),
                          width: "200"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_sku_info, {
                              brand_article_no: 
                      _ctx.getProductIdData(row.sku_identifier)?.brand_article_no
                    ,
                              color: 
                      _ctx.getProductIdData(row.sku_identifier)?.original_color
                    ,
                              size: _ctx.getProductIdData(row.sku_identifier)?.__show.size,
                              product_identifier_id: 
                      _ctx.getProductIdData(row.sku_identifier)
                        ?.product_identifier_id
                    
                            }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('salesOrder.orderNumber'),
                          width: "320"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("div", _hoisted_179, [
                              _createElementVNode("div", _hoisted_180, [
                                _createElementVNode("div", null, _toDisplayString(row.sale_order_number), 1),
                                _createElementVNode("div", _hoisted_181, " SUB#" + _toDisplayString(row.order_item_position) + " (" + _toDisplayString(row.quantity) + ") ", 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('order.quantity'),
                          prop: "quantity",
                          align: "right"
                        }, null, 8, ["label"]),
                        (
                  _ctx.formData.shipment_info.status !== '' &&
                  !_ctx.loading &&
                  _ctx.formData.shipment_info.invoice_status !== 0
                )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              label: "",
                              align: "right",
                              width: "100"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#modal_use_stock_out",
                                  onClick: ($event: any) => (_ctx.handleEditUseStockOut(row))
                                }, [
                                  _createElementVNode("span", _hoisted_183, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                  ])
                                ], 8, _hoisted_182)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ])), [
                    [_directive_loading, _ctx.options.loadingProducts]
                  ])
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_184, [
            _createElementVNode("div", _hoisted_185, [
              _createElementVNode("div", _hoisted_186, [
                _createElementVNode("h3", _hoisted_187, _toDisplayString(_ctx.t("logisticsServiceProvider.serviceProfile")), 1)
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_188, [
              _createElementVNode("div", _hoisted_189, [
                _createElementVNode("div", _hoisted_190, [
                  _createVNode(_component_el_table, {
                    data: _ctx.options.shipment_service_profile,
                    style: {"width":"100%"},
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('logisticsServiceProvider.name'),
                        prop: "name"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('logisticsServiceProvider.serviceLevel'),
                        prop: "service_level"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('logisticsServiceProvider.maximumWeight'),
                        prop: "maximum_weight"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["data"])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createElementVNode("div", _hoisted_191, [
            _createElementVNode("div", _hoisted_192, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light-primary",
                onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
              }, [
                _createElementVNode("span", _hoisted_193, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
              ]),
              _createElementVNode("div", _hoisted_194, [
                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                  default: _withCtx(() => [
                    (
                  _ctx.invoiceButtonGroupVisibleController('createProformaInvoice')
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.createProformaInvoice && _ctx.createProformaInvoice(...args))),
                          disabled: _ctx.loading || _ctx.options.createProformaInvoiceDisabled
                        }, [
                          (_ctx.options.createProformaInvoiceDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_196, [
                                (!_ctx.options.createProformaInvoiceDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/arrows/arr091.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_197))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.createProformaInvoice")), 1)
                        ], 8, _hoisted_195))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                  default: _withCtx(() => [
                    (
                  _ctx.invoiceButtonGroupVisibleController('createAgentDocuments')
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.createAgentDocuments && _ctx.createAgentDocuments(...args))),
                          disabled: _ctx.loading || _ctx.options.createAgentDocumentsDisabled
                        }, [
                          (_ctx.options.createAgentDocumentsDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_199, [
                                (!_ctx.options.createAgentDocumentsDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/arrows/arr091.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_200))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.createDocuments")), 1)
                        ], 8, _hoisted_198))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                  default: _withCtx(() => [
                    (_ctx.invoiceButtonGroupVisibleController('createDocuments'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.createDocuments && _ctx.createDocuments(...args))),
                          disabled: _ctx.loading || _ctx.options.createDocumentsDisabled
                        }, [
                          (_ctx.options.createDocumentsDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_202, [
                                (!_ctx.options.createDocumentsDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/arrows/arr091.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_203))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.createDocuments")), 1)
                        ], 8, _hoisted_201))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                  default: _withCtx(() => [
                    (
                  _ctx.invoiceButtonGroupVisibleController('previewProformaInvoice')
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.previewProformaInvoice && _ctx.previewProformaInvoice(...args))),
                          disabled: _ctx.loading || _ctx.options.previewProformaInvoiceDisabled
                        }, [
                          (_ctx.options.previewProformaInvoiceDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_205, [
                                (!_ctx.options.previewProformaInvoiceDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/arrows/arr093.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_206))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.printProformaInvoice")), 1)
                        ], 8, _hoisted_204))
                      : _createCommentVNode("", true),
                    (
                  _ctx.invoiceButtonGroupVisibleController('printCommercialInvoice')
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.previewDoubleSaleCommercialInvoice && _ctx.previewDoubleSaleCommercialInvoice(...args))),
                          disabled: 
                  _ctx.loading || _ctx.options.previewDoubleSaleCommercialInvoiceDisabled
                
                        }, [
                          (_ctx.options.previewDoubleSaleCommercialInvoiceDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_208, [
                                (!_ctx.options.previewDoubleSaleCommercialInvoiceDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/arrows/arr093.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_209))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.printCommercialInvoice")), 1)
                        ], 8, _hoisted_207))
                      : _createCommentVNode("", true),
                    (_ctx.invoiceButtonGroupVisibleController('printDeliveryNote'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.previewDeliveryNote && _ctx.previewDeliveryNote(...args))),
                          disabled: _ctx.loading || _ctx.options.previewDeliveryNoteDisabled
                        }, [
                          (_ctx.options.previewDeliveryNoteDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_211, [
                                (!_ctx.options.previewDeliveryNoteDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/arrows/arr093.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_212))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.printDeliveryNote")), 1)
                        ], 8, _hoisted_210))
                      : _createCommentVNode("", true),
                    (_ctx.invoiceButtonGroupVisibleController('printPackingList'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.printPackingList && _ctx.printPackingList(...args))),
                          disabled: _ctx.loading || _ctx.options.printPackingListDisabled
                        }, [
                          _withDirectives(_createElementVNode("span", null, [
                            _hoisted_214,
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                          ], 512), [
                            [_vShow, _ctx.loading || _ctx.options.printPackingListDisabled]
                          ]),
                          _withDirectives(_createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_215, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr091.svg" })
                            ]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("common.downloadPackingList")), 1)
                          ], 512), [
                            [_vShow, !_ctx.loading && !_ctx.options.printPackingListDisabled]
                          ])
                        ], 8, _hoisted_213))
                      : _createCommentVNode("", true),
                    (
                  _ctx.invoiceButtonGroupVisibleController('downloadPackingList')
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.downloadPackingList && _ctx.downloadPackingList(...args))),
                          disabled: _ctx.loading || _ctx.options.downloadPackingListDisabled
                        }, [
                          _withDirectives(_createElementVNode("span", null, [
                            _hoisted_217,
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                          ], 512), [
                            [_vShow, _ctx.loading || _ctx.options.downloadPackingListDisabled]
                          ]),
                          _withDirectives(_createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_218, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr091.svg" })
                            ]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("common.downloadPackingList")), 1)
                          ], 512), [
                            [_vShow, !_ctx.loading && !_ctx.options.downloadPackingListDisabled]
                          ])
                        ], 8, _hoisted_216))
                      : _createCommentVNode("", true),
                    (_ctx.invoiceButtonGroupVisibleController('printCheckList'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.printCheckList && _ctx.printCheckList(...args))),
                          disabled: _ctx.loading || _ctx.options.printCheckListDisabled
                        }, [
                          (_ctx.options.printCheckListDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_220, [
                                (!_ctx.options.printCheckListDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/svg/custom/print.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_221))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.printCheckList")), 1)
                        ], 8, _hoisted_219))
                      : _createCommentVNode("", true),
                    (_ctx.invoiceButtonGroupVisibleController('printStockOutList'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 6,
                          type: "button",
                          class: "btn btn-light text-primary",
                          onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.printStockOutList && _ctx.printStockOutList(...args))),
                          disabled: _ctx.loading || _ctx.options.stockOutListDisabled
                        }, [
                          (_ctx.options.stockOutListDisabled)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_223, [
                                (!_ctx.options.stockOutListDisabled)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/arrows/arr091.svg"
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_224))
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.stockOutList")), 1)
                        ], 8, _hoisted_222))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_225, [
                      _createElementVNode("span", _hoisted_226, [
                        _createElementVNode("span", _hoisted_227, [
                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_228, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_229
                      ])
                    ], 512),
                    (_ctx.formData.can_manually_delivered === 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-primary",
                          onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.handleReceivedShipment(_ctx.formData.id))),
                          disabled: _ctx.loading
                        }, [
                          _createElementVNode("span", _hoisted_231, [
                            _createElementVNode("span", _hoisted_232, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("shipments.received")), 1)
                          ]),
                          _createElementVNode("span", _hoisted_233, [
                            _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                            _hoisted_234
                          ])
                        ], 8, _hoisted_230))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _createVNode(_component_UseStockOut, {
      id: _ctx.shipmentItemId,
      parentId: Number(_ctx.$route.params.id),
      status: _ctx.formData.shipment_info.status,
      invoice_status: _ctx.formData.shipment_info.invoice_status,
      shipment_type: _ctx.formData.shipment_info.shipment_type,
      shipment_invoice_id: _ctx.formData.shipment_invoice_id,
      onResetForm: _ctx.handleUseStockOut,
      onUpdateList: _cache[51] || (_cache[51] = ($event: any) => (_ctx.getShowInfo(true)))
    }, null, 8, ["id", "parentId", "status", "invoice_status", "shipment_type", "shipment_invoice_id", "onResetForm"]),
    _createVNode(_component_addPreStockOutList, {
      id: Number(_ctx.$route.params.id),
      custom_declaration_by: _ctx.formData.carrier_information?.custom_declaration_by,
      submitData: _ctx.formData.shipment_info,
      shipment_invoice_id: _ctx.formData.shipment_invoice_id,
      onUpdateList: _cache[52] || (_cache[52] = ($event: any) => (_ctx.getShowInfo(true)))
    }, null, 8, ["id", "custom_declaration_by", "submitData", "shipment_invoice_id"])
  ], 64))
}